<template>
    <div v-if="!dataLoading">
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <div class="col-12">
                    <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('name')">
                            <b-form-input :state="errors[0] ? false : null" v-model="form.name">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 mt-2">
                    <ValidationProvider name="number_of_chairs" rules="required|numeric" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('number_of_chairs')">
                            <b-form-input type="number" :state="errors[0] ? false : null" v-model="form.number_of_chairs">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 mt-2">
                    <ValidationProvider name="explanation" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('explanation')">
                            <b-form-textarea :state="errors[0] ? false : null" v-model="form.explanation" rows="3">
                            </b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 mt-2">
                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <status-selectbox :validateError="errors[0]" v-model="form.status" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 mt-2">
                    <ValidationProvider name="device_id" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('device_id')">
                            <b-form-input type="text" :state="errors[0] ? false : null" v-model="form.device_id">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="updateForm" type="button" variant="primary" class="btn-lg mr-2" :disabled="formLoading">
                <b-spinner small v-if="formLoading"></b-spinner> {{ $t('save').toLocaleUpperCase('tr-TR') }}
            </b-button>
        </div>
    </div>
</template>

<script>
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    import LibraryRoomService from "@/services/LibraryRoomService";
    import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox";

    export default {
        components: {
            ValidationProvider, ValidationObserver, StatusSelectbox
        },
        props: {
            formId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                dataLoading: true,
                formLoading: false,
                form: {
                    id: null,
                    name: null,
                    number_of_chairs: null,
                    explanation: null,
                    status: 'a',
                    device_id: null,
                }
            }
        },
        created() {
            this.loadData();
        },
        methods: {
            loadData() {
                LibraryRoomService.get(this.formId)
                    .then(response => {
                        this.form = response.data.data;
                    })
                    .finally(() => {
                        this.dataLoading = false;
                    });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    LibraryRoomService.store(this.form)
                               .then((response) => {
                                   this.$toast.success(this.$t("api." + response.data.message));
                                   this.$emit("updateFormSuccess")
                               })
                               .catch((error) => {
                                   this.showErrors(error, this.$refs.formModalValidate)
                               }).finally(() => {
                        this.formLoading = false;
                    });
                }
            }
        }
    }
</script>
